import { IdentityProvider } from "../interfaces/IdentityProvider";

export class ProviderMapper {
    
  mapProviderToEnum(provider: string): IdentityProvider {
    switch ((provider || "").toLowerCase()) {
      case "google":
        return IdentityProvider.Google;
      case "microsoft":
        return IdentityProvider.Microsoft;
      case "spectacles":
        return IdentityProvider.EmailAndPassword;
      default:
        throw new Error(`Unknown provider: ${provider}`);
    }
  }
}
